var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-tick w-4 h-4 flex items-center justify-around custom-tick-border-color custom-tick-background-color",style:([_vm.customCss])},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"fa fa-check text-xs custom-tick-color"})])
}]

export { render, staticRenderFns }